import { store }                from 'index';
import { contentInfoType }      from 'types';
import getAppLessons            from 'functions/set_data/getAppLessons';
import { componentsStateType }  from 'reducer/types';
import { SET_COMPONENTS_STATE } from 'actions/componentsActions';
import { SET_SELECTED_APP }     from 'actions/contentActions';

const setFatherApp = (fatherApp: contentInfoType) => {

    const state = store.getState();

    const componentsState = state.components;
    const { lang }        = componentsState;
    const { lessons }     = state.content;

    const setComponentsState = (payload: componentsStateType) => store.dispatch(SET_COMPONENTS_STATE(payload));
    const setSelectedApp     = (payload: contentInfoType) => store.dispatch(SET_SELECTED_APP(payload));


    const appLessons = getAppLessons(lessons, fatherApp.lesson_id);

    setSelectedApp(fatherApp);

    const arabic = lang === 'ara' && !!fatherApp.arabic && `${ fatherApp.arabic }`.length > 0;
    const id     = arabic ? fatherApp.arabic : fatherApp.uid ? `${ fatherApp.uid }` : fatherApp.lesson_id;
    const appUrl = `https://www.yisumatica.org.il/flash-upload/js/js.html?lang=${ lang === 'heb' ? 'he' : 'ar' }&page=${ id }&exit_button=1`;

    setComponentsState({
      ...componentsState,
      sender:          'setFatherApp',
      selectedContent: 'apps',
      appUrl:          appUrl,
      appLessons:      appLessons
    })
 
}

export default setFatherApp;